import React from 'react';

const DebugScreen: React.FC = () => {
  return <></>;
};

export default DebugScreen;
